<template>
  <div class="item pt-1">
    <template v-if="mode === 'compact'">
      <p class="black--text compact-headline" @click="toggleExpand">
        {{ item.title }}
      </p>
      <div v-if="item.options && item.options.length" class="block">
        <v-chip
          v-for="(attr, index) in item.options"
          :key="`options-${index}`"
          class="ma-half"
          x-small
          >{{ attr }}</v-chip
        >
      </div>
      <div class="block">
        <v-chip
          v-for="(attr, index) in item.attributes"
          :key="`attr-${index}`"
          class="ma-half"
          :class="getColor(attr)"
          x-small
          >{{ attr }}</v-chip
        >
      </div>

      <div v-if="isExpanded" class="expanded">
        <div class="mt-1 black--text expanded__description">
          {{ item.description }}
        </div>
        <div class="block mt-1">
          <ul class="list-lines-small">
            <li v-for="(sub, count) in item.items" :key="`${index}-${count}`">
              {{ sub }}
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="icons pa-1">
          <div>
            <v-icon v-if="showControls" @click="edit(item)" class="black--text"
              >mdi-pencil</v-icon
            >
            <v-icon
              v-if="showControls && showDelete"
              @click="remove(item)"
              class="black--text ml-1"
              >mdi-delete-forever</v-icon
            >
          </div>

          <v-icon @click="toggleExpand" class="black--text"
            >mdi-arrow-expand</v-icon
          >
        </div>
      </div>
    </template>

    <template v-if="mode === 'full'">
      <div class="pa-2">
        <div class="d-flex flex-row justify-space-between align-start">
          <div>
            <h2 class="mb-2 mt-2">
              {{ item.title }}
            </h2>
            <div v-if="item.options" class="ma-0 pa-0">
              <v-chip
                v-for="(attr, index) in item.options"
                :key="`attr-${index}`"
                class="ma-1"
                :class="item.color"
                small
                >{{ attr }}</v-chip
              >
            </div>

            <div class="break-spaces mt-1">{{ item.description }}</div>
          </div>
          <div class="icons pa-1" v-if="showControls">
            <v-icon @click="edit(item)" class="black--text">mdi-pencil</v-icon>
            <v-icon
              @click="remove(item)"
              class="black--text"
              v-if="showControls && showDelete"
              >mdi-delete-forever</v-icon
            >
          </div>
        </div>

        <v-row class="mb-0 pb-0">
          <v-col cols="6">
            <p class="mb-1 mt-1">
              <strong>{{ audienceLabel }}</strong>
            </p>
            <v-chip
              v-for="(attr, index) in item.audience"
              :key="`attr-${index}`"
              class="ma-1"
              :class="item.color"
              >{{ attr }}</v-chip
            >
          </v-col>
          <v-col cols="6">
            <p class="mb-1 mt-1">
              <strong>{{ attributeLabel }}</strong>
            </p>
            <v-chip
              v-for="(attr, index) in item.attributes"
              :key="`attr-${index}`"
              class="ma-1"
              :class="getColor(attr)"
              >{{ attr }}</v-chip
            ></v-col
          >

          <v-col cols="12">
            <div class="block">
              <ul class="list-lines">
                <li
                  v-for="(sub, count) in item.items"
                  :key="`${index}-${count}`"
                >
                  {{ sub }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "BenefitsCard",
  data() {
    return {
      expanded: false,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    attributes: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
    thumbnail: {
      type: Boolean,
      default: false,
    },
    override: {
      type: Boolean,
      default: false,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: "full",
    },
  },
  methods: {
    edit() {
      this.$emit("edit", this.item.id);
    },
    remove() {
      this.$emit("remove", this.item.id);
    },
    toggleExpand() {
      console.log("toggle expand");
      this.expanded = !this.expanded;
    },
    getColor(title) {
      const item = this.attributes.find((x) => x.title === title);
      return item ? item.color : "";
    },
  },
  computed: {
    audienceLabel() {
      return this.item.audience == 1 ? "Audience" : "Audiences";
    },
    attributeLabel() {
      return this.item.attributes == 1 ? "Attribute" : "Attributes";
    },
    isExpanded() {
      return this.override ? true : this.expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-lines {
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin: 0 0 0.1rem 0;
    padding: 0.5rem 0;
    color: black;
    line-height: 1.6;
    list-style: none;
    border-bottom: 1px dotted rgba(0, 0, 0, 1);
    &:first-child {
      border-top: 1px dotted rgba(0, 0, 0, 1);
    }
    &:last-child {
      border-top: 1px dotted rgba(0, 0, 0, 0);
    }
  }
}
.compact-headline {
  font-weight: 500;
  line-height: 1.3;
  margin: 0.3rem 0 0.3rem 0;
  font-size: 1.1rem;
  padding: 0.2rem 0;
}
.expanded {
  &__description {
    font-size: 0.9rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    line-height: 1.2;
    font-weight: 500;
  }
  ul {
    margin-top: 0;
    margin-bottom: 1rem;
    li {
      font-size: 0.8rem;
      color: black;
      margin-bottom: 0.5rem;
      border-bottom: 1px dotted grey;
      padding: 0.2rem 0;
    }
  }
}
.icons {
  display: flex;
  justify-content: space-between;
}
.item {
  height: 100%;
}
</style>
